import type { ReactNode } from "react"
import { createContext, memo, useContext } from "react"
import { createPortal } from "react-dom"

const DecisionBarSlot = createContext<HTMLElement | null>(null)

export const DecisionBarProvider = DecisionBarSlot.Provider

/** Accept and Decline sit in the page header when it offers a slot, else under the change. */
export const DecisionBar = memo(({ children }: { children: ReactNode }) => {
	const slot = useContext(DecisionBarSlot)
	if (slot) return createPortal(children, slot)
	return <div className="flex items-center justify-end gap-2">{children}</div>
})
